import React, { useState, useEffect } from "react";
import gymgirl from "../../images/gymgirl.jpg";
import { Services } from "../../api/Services";
import { toast } from "react-toastify";
import { BASE_URL_MEDIA } from "../../api/Constants";
import { getImageUrl } from 'components/helpers/Helpers';

const currentDate = new Date();

const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, "0");
const day = String(currentDate.getDate()).padStart(2, "0");
const formattedDate = `${year}-${month}-${day}`;

// code add By Zohaib
const AssignForm = ({
  setAssignDataForm,
  getTrainerClientsSpecs,
  client,
  setShowSetting,
  isAssignProgram,
}) => {
  const [assignData, setAssignData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchUserinput, setSearchUserinput] = useState("");
  const [filterdPrograms, setFilterdPrograms] = useState([]);
  const [programStartDate, setprogramStartDate] = useState("");
  const [selectedProgramIndex, setSelectedProgramIndex] = useState(null);

  var tempId = null;

  //Hanlde user input to cahnge clients in form while seraching
  const handleuserinputChange = async (event) => {
    const newInputValue = event ? event.target.value : "";
    setSearchUserinput(newInputValue);

    try {
      if (newInputValue.trim() === "") {
        setSearchUserinput("");
      } else {
        const filtereProgram = assignData.filter((program) => {
          return isAssignProgram
            ? program.name.toLowerCase().includes(newInputValue.toLowerCase())
            : program.title.toLowerCase().includes(newInputValue.toLowerCase());
        });
        setFilterdPrograms(filtereProgram);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // for calling program list api on first load
  useEffect(() => {
    if (client.id !== tempId || tempId === null) {
      tempId = client.id;
      isAssignProgram ? getProgramms() : getGroups();
    }
  }, []);

  //APi call for program list
  const getProgramms = async () => {
    setIsLoading(true);
    try {
      const result = await Services.getProgrammsListLight();
      if (result.status === 200) {
        setAssignData(result?.data?.data);
      } else {
        toast.error("Some error occured while Loading Programs", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //APi call for groups list
  const getGroups = async () => {
    setIsLoading(true);
    try {
      const result = await Services.getTrainerDashboardGroups();
      if (result.status === 200) {
        setAssignData(result?.data?.data?.groups);
      } else {
        toast.error("Some error occured while Loading Groups", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //assign group user or groups
  const assignUsers = async (
    index,
    id,
    name,
    users,
    image,
    description,
    video,
    groupId,
    isFree,
    price,
    lock_future_weeks,
    communityId,
    programStartDate,
    number_of_weeks
  ) => {
    try {
      const result = await Services.editProgram(
        id,
        name,
        users,
        image,
        description,
        video,
        groupId,
        isFree,
        price,
        lock_future_weeks,
        communityId,
        programStartDate,
        number_of_weeks
      );

      if (result.status === 200) {
        toast.success("Assigned successfuly", {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });

        setTimeout(() => {
          setprogramStartDate("");
          setAssignData([]);
        }, 1000);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //assign user to trainer groups
  const assignGroup = async (group_id, members) => {
    try {
      const result = await Services.addGroupMembersV2(group_id, members);

      if (result.status === 200) {
        toast.success("Assigned successfuly", {
          autoClose: 1000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });

        setTimeout(() => {
          setAssignData([]);
        }, 1000);
      } else {
        toast.error(result?.data?.message, {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  // hadle user input for assing program to users
  const handleAssignData = async (program, index) => {
    try {
      if (isAssignProgram) {
        if (programStartDate === "") {
          toast.error("Program Start Date Can not be Empty", {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
            position: toast.POSITION.TOP_CENTER,
          });
          console.error("Program Start Date Can not be Empty");

          return;
        } else {
          await assignUsers(
            index,
            program.id,
            program?.name,
            client.id,
            program?.image,
            program?.desc,
            program?.video,
            "",
            program?.is_free,
            program?.price,
            program?.lock_future_weeks,
            program?.community_id,
            programStartDate,
            program?.number_of_weeks
          );
          closingform();
        }
      } else {
        await assignGroup(program.id, client.id);
        closingform();
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const closingform = () => {
    setAssignDataForm(false);
    setShowSetting(false);
    getTrainerClientsSpecs(client?.id, client?.image, client?.name);
  };

  // waiting Loader
  const loader = () => {
    return (
      <div class="three-body">
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
        <div class="three-body__dot"></div>
      </div>
    );
  };

  return (
    <div className=" assign-program excercise-modal assign-program trainings-modal mt-4 pt-4">
      <i
        className="fa fa-times"
        onClick={() => {
          setAssignDataForm(false);
          setAssignData([]);
        }}
      ></i>
      <p className="title-small">
        Assign {isAssignProgram ? `Program` : `Group`}
      </p>
      <div className="child-modal ">
        <div className="form-group relative ">
          <label htmlFor="">
            Search {isAssignProgram ? `Program` : `Group`}
          </label>
          <input
            type="text"
            value={searchUserinput}
            onChange={handleuserinputChange}
            placeholder={`Search ${isAssignProgram ? "Program" : "Group"}`}
            className="form-control input"
          />
        </div>
        <div className="content">
          <div className="assign-data-list">
            {!isLoading
              ? (searchUserinput === ""
                  ? assignData
                    ? assignData
                    : []
                  : filterdPrograms
                  ? filterdPrograms
                  : []
                ).map((programm, index) => (
                  <div className="assign-data" key={index}>
                    {programm?.image !== null ? (
                      <img
                        src={getImageUrl(programm?.image, BASE_URL_MEDIA)}
                        alt="assign-data-image"
                      />
                    ) : (
                      <img src={gymgirl} alt="program-dummy-image" />
                    )}
                    <div className="a-right-side" key={`${index}+`}>
                      <p className="assign-data-name">
                        {isAssignProgram
                          ? programm.name.length > 70
                            ? programm.name.slice(0, 70) + "..."
                            : programm.name
                          : programm.title.length > 70
                          ? programm.title.slice(0, 70) + "..."
                          : programm.title}
                      </p>
                      <div className="col-12 col-md-6 ">
                        <div className="form-group p-date">
                          {isAssignProgram && (
                            <label htmlFor="">Program start date</label>
                          )}
                          <div
                            className={`a-button-section ${
                              !isAssignProgram ? "col" : ""
                            }`}
                          >
                            {isAssignProgram ? (
                              <input
                                key={`${index}+`}
                                type="date"
                                className="form-control input"
                                min={formattedDate}
                                onChange={(e) =>
                                  setprogramStartDate(e.target.value)
                                }
                                onClick={() => setSelectedProgramIndex(index)}
                              />
                            ) : (
                              <div className="a-btn-gap"></div>
                            )}

                            <div
                              key={`${index}+`}
                              className={`a-button`}
                              onClick={() => {
                                if (
                                  selectedProgramIndex === index ||
                                  !isAssignProgram
                                )
                                  handleAssignData(programm, index);
                              }}
                            >
                              Assign
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : loader()}
          </div>
        </div>

        <div className="d-flex justify-content-between -mt-4 form-button ">
          <button
            className={`button ${"button-style-form"}`}
            onClick={() => {
              setAssignDataForm(false);
              setAssignData([]);
            }}
          >
            Close
          </button>{" "}
        </div>
      </div>
    </div>
  );
};

export default AssignForm;
